<template>
    <div>
        <off-canvas ref="canvas">
            <div class="py-8">
                <div class="pt-0 pb-4 mb-8 px-10 flex justify-center">
                    <logo style="max-width:120px"></logo>
                </div>
                <ul class="list-reset font-heading uppercase text-sm font-normal border-t border-menu">
                    <li class="pb-2 pt-2 px-10 text-lg border-b border-menu mb-0"
                        v-for="item in sortedMenuItems" :key="item.route">
                        <router-link ref="link" :to="item.route" active-class="font-bold" exact
                                     class="text-white no-underline hover:font-bold hover:text-grey-light flex items-center"
                        >
                            <span class="w-10">
                                <i :class="item.icon" class="text-xl"></i>
                            </span>
                            <span>
                                {{ trans(item.trans) }}
                            </span>
                        </router-link>
                    </li>
                    <li class="pb-2 pt-2 px-10 text-lg border-b border-menu mb-0">
                        <router-link to="/logout" active-class="font-bold" exact
                                     class="text-white no-underline hover:font-bold hover:text-grey-light flex items-center"
                        >
                            <span class="w-10">
                                <i class="fal fa-sign-out-alt text-xl"></i>
                            </span>
                            <span>
                                Log out
                            </span>
                        </router-link>
                    </li>
                </ul>
            </div>
        </off-canvas>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import HasSortedMenuItems from "../mixins/HasSortedMenuItems";

export default {
    mixins: [HasSortedMenuItems],

    computed: {
        ...mapState([
            'connectionStatus',
        ]),
    },

    data() {
        return {
            shouldLeave: false,
        }
    },

    created() {
        this.$store.dispatch('fetchApps');
    },

    methods: {
        toggle() {
            this.$refs.canvas.toggle()
        },
        close() {
            this.$refs.canvas.close()
        },
    },

    watch: {
        $route(to, from) {
            this.$refs.canvas.close()
        }
    }
}
</script>

<style>
.border-menu {
    border-color: rgba(255, 255, 255, 0.1)
}
</style>
